<template>
  <div
    class="owal-floating-logo__container"
  >
    <owal-logo
      class="owal-floating-logo__logo"
    />
    <div
      class="owal-floating-logo__logo-shadow"
    />
  </div>
</template>

<script>
import { OwalLogo } from '@/libraries/owal-ui'

export default {
  name: 'Loading',
  components: { OwalLogo },
}
</script>

<style scoped>

.owal-floating-logo__container {
  align-content: center;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  height: 100%;
  background: #EFF2F7;
}

.owal-floating-logo__logo,
.owal-floating-logo__logo-shadow {
  animation: 4s ease 50ms infinite alternate-reverse;
}

.owal-floating-logo__logo {
  z-index: 2;
  animation-name: float;
}

.owal-floating-logo__logo-shadow {
  position: relative;
  bottom: 0;
  height: 2rem;
  width: 100%;
  background: #475669;
  border-radius: 1rem;
  filter: blur(2rem);
  animation-name: shadow-float;
  z-index: 1;
  width: 6.625rem;
}

.owal-floating-logo__logo:hover {
  cursor: pointer;
}

/* .owal-floating-logo__logo:hover:before {
  animation: blink 600ms ease 0s 1;
  animation-fill-mode: both;
} */

.owal-floating-logo__logo:active:after {
  animation: blink 400ms ease 0s 1;
}

@keyframes float {
  0% {
    transform: scale(0.5) translateY(4.75rem) rotate(0deg);
  }

  90% {
    transform: scale(1.3) translateY(-5rem) rotate(-4deg);
  }

  100% {
    transform: scale(1.3) translateY(-5rem) rotate(-2.5deg);
  }
}

@keyframes shadow-float {
  from {
    background: rgba(71, 86, 105, 1);
    filter: blur(1.25rem);
    transform: scale(0.25) translateY(-1rem) rotateX(64deg);
    opacity: 0.95;
  }

  to {
    background: rgba(71, 86, 105, 1);
    filter: blur(2rem);
    transform: scale(1) translateY(2rem) rotateX(16deg);
    opacity: 0.25;
  }
}

@keyframes blink {
  0% {
    transform: scaleY(1) scaleX(1);
  }

  50% {
    transform: scaleY(0.01) scaleX(1.12);
  }

  100% {
    transform: scaleY(1) scaleX(1);
  }
}
</style>
